var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.602,
    height: 19.248,
    viewBox: "0 0 20.602 19.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marketing",
    transform: "translate(-88.161 -35.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17288",
    "data-name": "Path 17288",
    d: "M108.738,43.114a.49.49,0,0,1-.618.315l-1.784-.58a.491.491,0,0,1,.3-.933l1.784.58a.49.49,0,0,1,.315.618Zm-5.059-4.939a.49.49,0,0,0,.582-.378l.39-1.834a.491.491,0,0,0-.96-.2l-.39,1.834a.49.49,0,0,0,.378.582Zm2.724,1.7,1.611-.93a.491.491,0,0,0-.491-.85l-1.611.93a.491.491,0,1,0,.491.85Zm-1.022,6.03a1.474,1.474,0,0,1-1.274,2.211,1.479,1.479,0,0,1-1.081-.47A19.605,19.605,0,0,0,96.61,49.43l2.664,2.664a.49.49,0,0,1,0,.694l-1.686,1.686a.49.49,0,0,1-.693,0l-3.343-3.342a3.141,3.141,0,0,1-4.114-1.243l-.857-1.484a3.143,3.143,0,0,1,1.149-4.289L92.012,42.8a19.816,19.816,0,0,0,5.307-5.039A1.474,1.474,0,0,1,100,36.591l1.568,2.717.129-.074a2.24,2.24,0,0,1,2.24,3.88l-.129.074Zm-3.318-5.747,1.259,2.181.129-.074a1.259,1.259,0,0,0-1.259-2.18Zm-9.14,3.212,3.048,5.279a20.8,20.8,0,0,1,6.478-1.926l-4.618-8a20.791,20.791,0,0,1-4.907,4.647Zm.313,6.821,1.87-1.079L92.09,43.887l-1.87,1.079a2.161,2.161,0,0,0-.79,2.949l.857,1.484a2.161,2.161,0,0,0,2.949.79Zm5,2.252L95.695,49.9l-1.259.727,2.8,2.8Zm6.3-6.047-5.377-9.313a.493.493,0,0,0-.854.493l5.377,9.313a.492.492,0,0,0,.9-.119.488.488,0,0,0-.048-.374Z",
    transform: "translate(0 0)",
    fill: "#bebfb6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.9886351d88892b8c45bc7dcc55262b45.svg";
export { ForwardRef as ReactComponent };